import { HOME_PAGE } from 'constants/pages';
import { ButtonLink } from 'components/Button';
import { OnboardingStepEnum } from '../../CoachLoggedInScreen/props';

const TEXTS = {
  HEADING: 'Unlock 43% more lessons',
  HEADING_2: '(3 easy steps)',
  DESCRIPTIONS:
    "Set your schedule and connect your bank account to enable Instant Booking. Coaches who do this get 43% more clients — and payments go straight to your bank account. If you choose not to, players can still message you but you'll receive fewer enquiries.",
  BUTTONS: 'Set up instant booking',
} as const;

interface CompleteProfileProps {
  needBankInformation: boolean;
  hasDisabledAvailability: boolean;
  onConnectBankAccount: () => void;
  isCoachOfPage: boolean;
}

const CompleteProfile = ({
  needBankInformation,
  hasDisabledAvailability,
  onConnectBankAccount,
  isCoachOfPage,
}: CompleteProfileProps) => {
  if (!needBankInformation && !hasDisabledAvailability && !isCoachOfPage) {
    return null;
  }

  const isBankAccountCase = needBankInformation;
  const isAvailabilityCase = hasDisabledAvailability;

  const heading = TEXTS.HEADING;
  const heading_2 = TEXTS.HEADING_2;

  const description = TEXTS.DESCRIPTIONS;

  return (
    <div className="flex flex-col rounded-xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary p-6 shadow-lightmode-primary dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary">
      <h3 className="typography-product-heading text-color-brand-primary">{heading}</h3>
      <h3 className="typography-product-heading text-color-brand-primary">{heading_2}</h3>
      <p className="typography-product-body mt-4 text-left text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {description}
      </p>

      <div className="mt-6">
        <ButtonLink
          variant="brand"
          size="lg"
          href={`${HOME_PAGE}?step=${
            isBankAccountCase ? OnboardingStepEnum.PAYMENTS : OnboardingStepEnum.SCHEDULE
          }`}
          className="mx-auto"
        >
          {TEXTS.BUTTONS}
        </ButtonLink>
      </div>
    </div>
  );
};

export default CompleteProfile;
